import {gsap} from "../utils/vendor.js";

/**
 * Gestisce l’effetto fade degli elementi nelle quattro direzioni, allo scroll della pagina.
 *
 * Il codice prevede un elemento padre e uno o più elementi figli. L’animazione dei figli parte
 * poco dopo che il padre è entrato nel viewport. Esempio di codice HTML:
 *
 * <div data-fade-trigger>
 *     <div data-fade="up" />
 *     <div data-fade="down" />
 *     <div data-fade="left" />
 *     <div data-fade="right" />
 * </div>
 */

let timelines = [];

export default class ScrollAnimationsComponent {
    init() {
        document.querySelectorAll('[data-fade-trigger]').forEach(trigger => {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: trigger,
                    start: "top 90%", // when the top of the trigger hits 90% down from the top of the viewport
                    once: false
                }
            });

            timelines.push(timeline);

            const to = {
                x: 0, // left & right
                y: 0, // up & down
                opacity: 1,
                duration: 1.2,
                ease: "expo.out"
            };

            trigger.querySelectorAll("[data-fade]").forEach(el => {
                switch (el.dataset.fade) {
                    case "up":
                        timeline.fromTo(el, {y: 50, opacity: 0}, to, "<0.2");
                        break;

                    case "down":
                        timeline.fromTo(el, {y: -50, opacity: 0}, to, "<0.2");
                        break;

                    case "right":
                        timeline.fromTo(el, {x: -50, opacity: 0}, to, "<0.2");
                        break;

                    case "left":
                        timeline.fromTo(el, {x: 50, opacity: 0}, to, "<0.2");
                        break;
                }
            });
        });
    }

    beforeTransition() {
        timelines.forEach(tl => tl.revert());
    }
}
